import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type YandexMarketImportResponse as SchemaYandexMarketImportResponse } from '../schemas/YandexMarketImportResponse';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Integrations
 */
export const ImportYandexMarketSetupGetContentType = '' as const;
export type ImportYandexMarketSetupGetRequest = void;
export type ImportYandexMarketSetupGetResponses = LinkCommonErrorResponses & {
    /**
     * @description Yandex market import settings set successfully
     */
    '200': {
        'application/json': SchemaYandexMarketImportResponse;
    };
};
export type ImportYandexMarketSetupGetResponseSuccess = ImportYandexMarketSetupGetResponses['200']['application/json'];
export type ImportYandexMarketSetupGetSearchParams = undefined;
export type ImportYandexMarketSetupGetPathParameters = undefined;
export const ImportYandexMarketSetupGetUrl = '/integrations/yamarket/setup' as const;
export const ImportYandexMarketSetupGetMethod = 'GET' as const;
export const getImportYandexMarketSetupGetUrl = (_params?: ImportYandexMarketSetupGetPathParameters) =>
    ImportYandexMarketSetupGetUrl;
